import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultFontSetting,
  defaultPaddingSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultIconSetting,
  defaultComplexFontSetting,
  defaultSimpleFontSetting
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "enableTips",
    desc: "显示提示文字",
    type: "booleanSet",
    defaultValue: true
  },
  {
    name: "tipsText",
    desc: "文字",
    type: "simpleFontSet",
    defaultValue: {
      ...defaultSimpleFontSetting
    }
  },
  {
    name: "tipsBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "tipsBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting
    }
  },
  {
    name: "showTipsBorder",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "tipsRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "tipsDis",
    desc: "偏移",
    type: "numberSet",
    defaultValue: 8
  },
  {
    name: "tipsOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "tipsShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "tipsPadding",
    desc: "内边距",
    type: "paddingSet",
    defaultValue: defaultPaddingSetting
  },
]

export const menuSetting = [
  "enableTips",
  {
    type: "collection",
    enable(config) {
      return config.enableTips
    },
    settings: [
      {
        type: "collapse",
        title: "位置",
        settings: [
          "tipsDis",
        ]
      },
      {
        type: "collapse",
        title: "文字",
        settings: [
          "tipsText",
        ]
      },
      {
        type: "collapse",
        title: "背景",
        settings: ["tipsBackground"]
      },
      {
        type: "collapse",
        title: "边框",
        settings: [
          "showTipsBorder",
          {
            type: "basic",
            name: "tipsBorder",
            enable(config) {
              return config.showTipsBorder
            }
          },
          "tipsRadius"
        ]
      },
      {
        type: "collapse",
        title: "边距",
        settings: ["tipsPadding"]
      },
      {
        type: "collapse",
        title: "更多",
        settings: ["tipsOpacity", "tipsShadow"]
      }
    ]
  }
]
